import React from "react";
import Seo from "../components/SEO";
import Layout from "../components/layout";
import ResumeSection from "../containers/resume-section";

const ResumePage = () => {
  return (
    <Layout>
      <Seo
        title="Resume"
        description="Parmeet Asija's Resume details with download option"
      />
      <ResumeSection compensateHeaderGap />
    </Layout>
  );
};

export default ResumePage;
